// organisationActions.js

import { createAsyncThunk } from "@reduxjs/toolkit"
import { axiosDelete, axiosGet, axiosPost } from "../../utilities/axiosRequest"
import {
    fetchOrganisationsURL,
    insertOrUpdateTodoURL,
    getTodoByIdURL,
    deleteTask,
    insertOurUpdateOrgURL,
    lookupsURL,
} from "../../apiEndPoints"
import {
    fetchOrganisationsRequest,
    fetchOrganisationsSuccess,
    fetchOrganisationsFailure,
    updateTodos,
    updateSelectedOrg,
    updatePatientSummaryTemplateCategories,
} from "./organisationSlice"
import { logTransaction } from "../appActions"

export const fetchOrganisation = (orgId, success, failure) => {
    let url = fetchOrganisationsURL
    url += `?organizationId=${orgId}`

    return (dispatch, getState) => {
        const program = getState().user.program
        // dispatch(fetchOrganisationsRequest())
        axiosPost(url + `&programId=${program?.id || 1}`, {})
            // axiosPost(url, {})
            .then(response => {
                const organisations = response.data.responseData || []
                // dispatch(logTransaction("Fetch Organisations", response))
                // dispatch(fetchOrganisationsSuccess(organisations))
                // if (organisations.length === 1) {
                //     dispatch(
                //         updateSelectedOrg({
                //             organizationId: organisations[0].organizationId,
                //             organizationName: organisations[0].organizationName,
                //         })
                //     )
                // }
                console.log(response.data.responseData, "sdklfjdlskfjdslfjlkf")
                success && success(response.data.responseData)
            })
            .catch(err => {
                console.log(err, "sdklfjdlskfjdslfjlkf")
                // dispatch(logTransaction("Fetch Organisations failure", err))
                // dispatch(fetchOrganisationsFailure(err.message))
                failure && failure()
            })
    }
}

export const fetchOrganisations = (
    user,
    success,
    failure,
    pageNo = 0,
    pageSize = 100,
    both = false,
    orgName = ""
) => {
    let url = fetchOrganisationsURL
    url += `?pageNo=${pageNo}&pageSize=${pageSize}&orgName=${orgName}`
    if (
        user.userResources?.[0]?.role_id !== "Doctorite_Admin_Seeded" &&
        user?.organizationlistforuser?.[0]?.organizationId
    ) {
        url += `&organizationId=${user?.organizationlistforuser?.[0]?.organizationId}`
    }
    if (both) {
        url += `&isActive=both`
    }

    return dispatch => {
        dispatch(fetchOrganisationsRequest())
        axiosPost(url, {})
            .then(response => {
                const organisations = response.data.responseData || []
                dispatch(logTransaction("Fetch Organisations", response))
                dispatch(fetchOrganisationsSuccess(organisations))
                if (organisations.length === 1) {
                    dispatch(
                        updateSelectedOrg({
                            organizationId: organisations[0].organizationId,
                            organizationName: organisations[0].organizationName,
                        })
                    )
                }
                success && success(response.data.responseData)
            })
            .catch(err => {
                dispatch(logTransaction("Fetch Organisations failure", err))
                dispatch(fetchOrganisationsFailure(err.message))
                failure && failure()
            })
    }
}

export const fetchOrganisationsCount = (
    user,
    success,
    failure,
    orgName = ""
) => {
    // let isMaster = user?.profileForUser[0]?.isMaster;
    // var dataSource = {
    //   source: "PORTAL",
    //   clinicId: !isMaster ? user?.clinicListForUser?.[0]?.clinicId : undefined,
    // }

    let url = fetchOrganisationsURL + `?isCount=true&orgName=${orgName}`
    // url += `?pageNo=${page}&pageSize=${pageSize}`;

    if (
        user?.userResources?.[0]?.role_id !== "Doctorite_Admin_Seeded" &&
        user?.organizationlistforuser?.[0]?.organizationId
    ) {
        url += `&organizationId=${user?.organizationlistforuser?.[0]?.organizationId}`
    }

    return dispatch => {
        axiosPost(url, {})
            .then(response => {
                const organisations = response.data.responseData || []
                dispatch(
                    logTransaction(
                        "Fetch Organisations count success",
                        response
                    )
                )
                success && success(response.data.responseData)
            })
            .catch(err => {
                dispatch(
                    logTransaction("Fetch Organisations count failure", err)
                )
                failure && failure()
            })
    }
}

export const insertOrUpdateTodo = (todoData, success, error) => {
    return (dispatch, getState) => {
        axiosPost(insertOrUpdateTodoURL, todoData)
            .then(response => {
                if (response.data.statusCD === 200) {
                    dispatch(logTransaction("Insert or update todo", response))

                    // Dispatch the updateTodos action with the new task
                    success(response.data.statusMSG)
                } else {
                    dispatch(
                        logTransaction("Insert or update todo error", response)
                    )
                    error(response.data.statusMSG)
                }
            })
            .catch(err => {
                dispatch(logTransaction("Insert or update todo failure", err))
                error(err.message)
            })
    }
}

export const deleteTodo = (id, success, error) => {
    return (dispatch, getState) => {
        let url = deleteTask + `${id}`
        axiosDelete(url)
            .then(response => {
                if (response.data.statusCD === 200) {
                    dispatch(logTransaction("Insert or update todo", response))

                    // Dispatch the updateTodos action with the new task
                    success(response.data.statusMSG)
                } else {
                    dispatch(
                        logTransaction("Insert or update todo error", response)
                    )
                    error(response.data.statusMSG)
                }
            })
            .catch(err => {
                dispatch(logTransaction("Insert or update todo failure", err))
                error(err.message)
            })
    }
}

export const fetchTodoById = () => {
    return function (dispatch, getState) {
        let user = getState().login.user
        let id = user?.profileForUser[0]?.userId

        let url = getTodoByIdURL + `?createdBy=${id}`
        axiosGet(url)
            .then(response => {
                if (
                    response.data.statusCD == 200 &&
                    response.data.responseData != null &&
                    response.data.responseData.length > 0
                ) {
                    // let data = response.data.responseData;
                    dispatch(updateTodos(response.data.responseData))
                    dispatch(logTransaction("Fetch todo by id", response))
                } else {
                    dispatch(logTransaction("Fetch todo by id error", response))
                }
            })
            .catch(err => {
                dispatch(logTransaction("Fetch todo by id failure", err))
            })
    }
}

export const insertOrUpdateOrg = (data, success, failure) => {
    return function (dispatch, getState) {
        let url = insertOurUpdateOrgURL
        axiosPost(url, JSON.stringify(data))
            .then(response => {
                if (response.data.statusCD == 200) {
                    // let data = response.data.responseData;
                    success(response.data.responseData)
                } else {
                    failure(response.data.statusMSG)
                }
            })
            .catch(err => {
                failure("Failed to update organization details")
            })
    }
}

export function fetchSummaryTemplateCategories(success, failure = () => {}) {
    return function (dispatch, getState) {
        console.log("asydegfcygefdcuygsfcuf")
        let url = lookupsURL + `?lookupCategoryId=${10131}`
        const program = getState().user.program
        console.log(program, "asfkducbajksfcajhef")
        axiosGet(url)
            .then(response => {
                console.log(response, "sefuvhsufg")
                if (
                    response.data.statusCD == 200 &&
                    response.data.responseData &&
                    response.data.responseData.length > 0
                ) {
                    success(
                        response.data.responseData
                            .filter(template => template.status)
                            .sort((a, b) => a.lookupId - b.lookupId)
                    )
                    dispatch(
                        updatePatientSummaryTemplateCategories(
                            response.data.responseData
                        )
                    )
                } else {
                    failure(
                        response.data.statusMSG ||
                            "Error while fetching time spent categories"
                    )
                }
            })
            .catch(err => {
                failure("Error while fetching time spent categories")
            })
    }
}
